import CampaignResults from './components/CampaignResultsPrint';
import './assets/CampaignResultsPrint.css';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';
import withRouter from 'react-router-dom/withRouter';

import { loadEngagementsForCampaign } from '../../shared/redux/entities/actions';

import { loadKPIsForCampaign } from '../../shared/redux/kpis/actions';

import { getEngagementsWithKPIs } from '../../shared/redux/selectors';

function mapStateToProps(state,props){
  const campaignId = props.match.params.campaignId,
    campaign = get(state,['entities','campaigns',campaignId],{});

  return {
    campaignId:campaignId,
    campaignName:campaign.name,
    campaignUseCTA:campaign.useCTA,
    salesNumber:campaign.salesNumber,
    brandName:get(state,['entities','companies',campaign.companyId,'name']),
    launchDate:campaign.launchDate,
    endDate:campaign.endDate,
    engagements:values(state.entities.engagements).filter((e) => e.campaignId === campaignId),
    engagementKPIs:get(state,['kpis','campaigns',campaignId,'engagementKPIs'],[]),
    averageAdjoyability:get(state,['kpis','campaigns',campaignId,'averageRating'],0),
    averageTime:get(state,['kpis','campaigns',campaignId,'avgTimeSpent'],0),
    totalTimeSpent:get(state,['kpis','campaigns',campaignId,'totalTimeSpent'],0),
    totalCompletions:get(state,['kpis','campaigns',campaignId,'totalCompletions'],0),
    totalEngagements:get(state,['kpis','campaigns',campaignId,'totalEngagements'],0),
    totalUniqueCtaClickCount:get(state,['kpis','campaigns',campaignId,'totalUniqueCtaClickCount'],0),
    totalCtaClickCount:get(state,['kpis','campaigns',campaignId,'totalCtaClickCount'],0),
    engagementsWithKPIs:getEngagementsWithKPIs(state)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadEngagementsForCampaign,
    loadKPIsForCampaign
  },dispatch);
}


export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CampaignResults));



// WEBPACK FOOTER //
// ./src/routes/CampaignResultsPrint/index.js